// @flow
import * as React from 'react';
import interpolateComponents from 'interpolate-components';
import Container from 'components/Container';
import Link from 'components/Link';
import { H1 } from 'components/Heading';
import { configValue } from 'utils/config';

const ErrorSection = ({
  error /* error saved to redux by async code */
}: {
  error: Object
}) => (
  <>
    <H1>
      {/* TRANSLATORS: error page title */ getText('Something Went Wrong')}
    </H1>

    <Container mt={3}>
      {interpolateComponents({
        mixedString: /* TRANSLATORS: error page title */ getText(
          "We're sorry, something went wrong. Please try again and if the problem persists, please {{link}}contact us{{/link}}."
        ),
        components: {
          link: <Link href="/help" />
        }
      })}
    </Container>
    {configValue('idealist', 'devStackTrace') && error && (
      <Container mt={3} color="scarlet">
        {error.toString()}
        {error.stack}
      </Container>
    )}
  </>
);

export default ErrorSection;
